<template>
  <footer class="footer" :class="{ paddingMore: paddingMore }">
    <div class="link-box">
      <a
        class="service-link link"
        href="javascript:;"
        @click="openServiceLink"
        >{{ letter.fwtk }}</a
      >
      <a
        class="policy-link link"
        href="javascript:;"
        @click="openPrivacyLink"
        >{{ letter.yszc }}</a
      >
      <a
        v-if="paypricyLink && paypricy"
        href="javascript:;"
        @click="openPaypricyLink"
        class="policy-link link"
        >{{ paypricy }}</a
      >
    </div>
    <p class="copyright" v-html="copyright"></p>
  </footer>
</template>

<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGameLanguage } from '@store/languages/gameConf';
import serviceLink from '@mixins/officialWebStore/serviceLink';
import { getCopyright } from '@utiles/reviewFooter';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'pageFooter',
  mixins: [serviceLink],
  props: {
    paddingMore: {
      default: false
    }
  },
  data() {
    let copyright = `COPYRIGHT © ${location.host.toUpperCase()} ALL RIGHTS RESERVED.`;
    // 2024.08.23 邓智轩：送审域名+对应游戏+带参数p=rupay时替换copyright
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id') ||
      globalConfig.getHrefParam('gameID') ||
      '';
    return {
      copyright: getCopyright(gameId) || copyright
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    paypricyLink() {
      return getGameLanguage('', 'paypricyLink', this.gameId);
    },
    paypricy() {
      return getGameLanguage('', 'paypricy', this.gameId);
    },
    gameId() {
      return this.$store.state.gameId;
    }
  },
  methods: {
    openPaypricyLink() {
      this.openLink(this.paypricyLink);
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  position: relative;
  width: 100%;
  padding: 39px 24px;
  box-sizing: border-box;

  &.paddingMore {
    padding-bottom: 300px;
  }
}

.copyright {
  color: #333;
  text-align: center;
  font-size: 20px;
}

.link-box {
  text-align: center;
  position: relative;
  margin-bottom: 14px;
}

.link {
  display: inline-block;
  margin: 0 10px;
  font-size: 20px;
  color: #333;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}
</style>
